import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConsolePage } from './pages/ConsolePage';
import './App.scss';
import FirstPage from './pages/FirstPage';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    if (window.self === window.top) {
      window.location.replace("https://speak.englishtodayusa.com/");
    }
  }, []);
  return (
    <div data-component="App">
      <Router>
        <Routes>
          <Route path="/" element={<ConsolePage />} />
          <Route path="/choose_levels" element={<FirstPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
